import type { ReactNode } from 'react';
import { TabBar } from './TabBar.js';

interface ShellProps {
  children: ReactNode;
  fullBleed?: boolean;
  hideTabBar?: boolean;
}

export function Shell({ children, fullBleed, hideTabBar }: ShellProps) {
  return (
    <div className="mx-auto flex h-full min-h-svh max-w-mobile flex-col bg-bg">
      <main className={'relative flex-1 ' + (fullBleed ? '' : 'pb-20')}>{children}</main>
      {hideTabBar ? null : <TabBar />}
    </div>
  );
}
